import confetti from './confetti.json';
import done from './done.json';
export default {
  confetti,
  done,
};
